<template>
  <div class="billing">
    <div
      class="header"
      :style="{
        'flex-direction': !isDesktop && 'column',
        'align-items': !isDesktop && 'start',
      }"
    >
      <DateRangePicker
        :beginTime="7"
        :endTime="0"
        @change="onChange"
      ></DateRangePicker>
      <a-button
        type="primary"
        :style="{
          width: !isDesktop && '30%',
          'margin-top': !isDesktop && '8px',
        }"
        @click="handleDownload"
        >Download</a-button
      >
    </div>
    <a-spin :spinning="spinning">
      <a-table
        :pagination="pagination"
        :columns="tableColumns"
        :data-source="tableData"
        style="margin-top:10px;"
        :scroll="{ x: !isDesktop ? true : false }"
        @change="onTableChange"
      >
        <template #type="{text}">
          {{ typeFilter(text) }}
        </template>
        <template #status="{text}">
          <a-tag v-if="text === 0" color="warning">Pending</a-tag>
          <a-tag v-else-if="text === 1" color="success">Success</a-tag>
          <a-tag v-else-if="text === 2" color="error">Reject</a-tag>
        </template>
      </a-table>
    </a-spin>
  </div>
</template>

<script>
import { fetchGetAllBillingDetails } from '@/api/billing'
import { billingTypes, billingStatus } from '@/utils/database'
import DateRangePicker from '@/components/DateRangePicker'

const tableColumns = [
  {
    title: 'Date',
    dataIndex: 'dateTime',
  },
  {
    title: 'Type',
    dataIndex: 'type',
    slots: { customRender: 'type' },
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
  },
  {
    title: 'Amount Balance',
    dataIndex: 'accountBalance',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    slots: { customRender: 'status' },
  },
  {
    title: 'Comment',
    dataIndex: 'comment',
  },
]

export default {
  name: 'Billing',
  components: { DateRangePicker },
  data() {
    return {
      formList: {
        limit: 10,
        page: 1,
        beginTime: undefined,
        endTime: undefined,
      },
      tableData: [],
      tableColumns,
      billingTypes,
      pagination: {
        total: 0,
        current: 1,
        showSizeChanger: false,
        pageSize: 10,
        showTotal: (total) => {
          return `Total: ${total}`
        },
      },
      spinning: false,
    }
  },
  computed: {
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  methods: {
    getList(page) {
      if (page) this.formList.page = page
      this.spinning = !this.spinning
      this.$store
        .dispatch('billing/GetAllBillingDetails', this.formList)
        .then((res) => {
          this.tableData = res.list
          this.pagination.total = res.total
        })
        .finally(() => {
          this.spinning = !this.spinning
        })
    },
    onChange(beginTime, endTime) {
      this.formList.beginTime = beginTime
      this.formList.endTime = endTime
      this.getList(1)
    },
    onTableChange(pagination) {
      this.pagination = pagination
      this.getList(pagination.current)
    },
    typeFilter(value) {
      return billingTypes.find((item) => item.value === value).label
    },
    handleDownload() {
      const query = { ...this.formList }
      query.page = 1
      query.limit = 100000
      fetchGetAllBillingDetails(query).then((res) => {
        import('@/vendor/Export2Excel').then((excel) => {
          // 表头
          const header = {
            sheet1: [
              'Date',
              'Type',
              'Amount',
              'Amount Balance',
              'Status',
              'Comment',
            ],
          }
          const filterVal = [
            'dateTime',
            'type',
            'amount',
            'accountBalance',
            'status',
            'comment',
          ]
          const list = res.list
          const data = { sheet1: this.formatJson(filterVal, list) }
          excel.export_json_to_excel({
            header,
            data,
            filename: 'Account Details',
            autoWidth: true,
            bookType: 'xlsx',
          })
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((row) =>
        filterVal.map((attr) => {
          if (attr === 'type') {
            return billingTypes.find((item) => item.value === row[attr]).label
          } else if (attr === 'status') {
            return billingStatus.find((item) => item.value === row[attr]).label
          }
          return row[attr]
        }),
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.billing {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;

  .header {
    display: flex;
    justify-content: space-between;
  }
}
</style>
